<template>
  <component :is="selectedComponent" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import UserDetails from '@/views/users/UserDetails.vue'
import BitburstUserDetails from '@/views/users/BitburstUserDetails.vue'

export default {
  name: 'UserDetailsRoute',
  inheritAttrs: false,
  components: {
    UserDetails,
    BitburstUserDetails
  },
  computed: {
    selectedComponent () {
      const currentAdmin = this.$store.state.auth.AppActiveAdmin
      return currentAdmin && currentAdmin.publisher_ids !== null ? 'BitburstUserDetails' : 'UserDetails'
    }
  }
}
</script>